import React, { useState } from 'react';

import { Box, Tab, Tabs, Typography } from '@mui/material';

import PermissionedComponent from '~/components/Common/PermissionedComponent';

import { ROLE_ADMIN_USER, ROLE_LUX_LOYALTY_ADMIN } from '~/consts/roles';

import { loyaltySubTabsContainerSx } from '../loyaltyTabStyles';

import ConciergeTab from './ConciergeTab';
import CreateInfiniteAccountTab from './CreateInfiniteAccountTab';

type ParentTabKey = 'create-account' | 'concierge';

/**
 * Top-level Infinite page. Hosts two parent sub-tabs:
 *  - Infinite Enrolment: stepped flow to upgrade an existing LE customer or register
 *    a new customer and enrol at Infinite.
 *  - Concierge: existing Assignments + Representatives experience.
 */
export default function InfiniteConciergePage() {
  const [tab, setTab] = useState<ParentTabKey>('create-account');

  return (
    <PermissionedComponent
      requiredRoles={[ROLE_ADMIN_USER, ROLE_LUX_LOYALTY_ADMIN]}
      fallback={
        <Typography color="text.secondary">You don&apos;t have permission to manage Infinite assignments.</Typography>
      }
    >
      <Box sx={loyaltySubTabsContainerSx}>
        <Tabs value={tab} onChange={(_, next) => setTab(next as ParentTabKey)}>
          <Tab value="create-account" label="Infinite Enrolment" />
          <Tab value="concierge" label="Concierge" />
        </Tabs>
      </Box>

      {tab === 'create-account' && <CreateInfiniteAccountTab />}
      {tab === 'concierge' && <ConciergeTab />}
    </PermissionedComponent>
  );
}
